import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "portalId", "render"],
  _excluded2 = ["playlistId", "render"],
  _excluded3 = ["playlistId", "portalId", "renderAssignments", "renderPortals"];
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { usePlaylistAssignmentsForPortal, usePlaylistAssignmentsPortals } from '../playlistAssignmentsQueries';
import { LazyLoadScrollContainer } from '../../lazyLoad/components/LazyLoadScrollContainer';
import CardSearchInput from '../../cardMenu/components/CardSearchInput';
import { TABLE_SIZE } from '../../table/tableTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentsSearchContext = /*#__PURE__*/createContext({
  selectedPortalId: null,
  selectPortal: () => {},
  unselectPortal: () => {}
});
export const usePlaylistAssignmentsSearchContext = () => useContext(PlaylistAssignmentsSearchContext);
export const PlaylistAssignmentsSearchProvider = ({
  children
}) => {
  const [selectedPortalId, setSelectedPortalId] = useState(null);
  const selectPortal = useCallback(portalId => setSelectedPortalId(portalId), []);
  const unselectPortal = useCallback(() => setSelectedPortalId(null), []);
  const contextState = useMemo(() => ({
    selectedPortalId,
    selectPortal,
    unselectPortal
  }), [selectPortal, selectedPortalId, unselectPortal]);
  return /*#__PURE__*/_jsx(PlaylistAssignmentsSearchContext.Provider, {
    value: contextState,
    children: children
  });
};
const PlaylistAssignmentsForPortalSearch = _ref => {
  let {
      playlistId,
      portalId,
      render
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [query, setQuery] = useState();
  const [page, setPage] = useState(1);
  const {
    playlistAssignmentsForPortal,
    playlistAssignmentsForPortalLoading,
    total
  } = usePlaylistAssignmentsForPortal({
    playlistId,
    portalId,
    offset: (page - 1) * TABLE_SIZE,
    query
  });
  const handleSearchChange = useCallback(searchQuery => {
    setQuery(searchQuery);
    setPage(1);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CardSearchInput, {
      onSearchChange: handleSearchChange,
      placeholder: "academyCommon.topFilters.searchUser.placeholder"
    }), /*#__PURE__*/_jsx(LazyLoadScrollContainer, Object.assign({
      data: playlistAssignmentsForPortal,
      loadNextPage: () => setPage(page + 1),
      loading: playlistAssignmentsForPortalLoading,
      page: page,
      render: render,
      state: query,
      total: total || 0
    }, props))]
  });
};
const PlaylistAssignmentsPortalsSearch = _ref2 => {
  let {
      playlistId,
      render
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const [query, setQuery] = useState();
  const [page, setPage] = useState(1);
  const {
    playlistAssignmentsPortals,
    total,
    playlistAssignmentsPortalsLoading
  } = usePlaylistAssignmentsPortals({
    playlistId,
    offset: (page - 1) * TABLE_SIZE,
    query
  });
  const handleSearchChange = useCallback(searchQuery => {
    setQuery(searchQuery);
    setPage(1);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CardSearchInput, {
      onSearchChange: handleSearchChange,
      placeholder: "academyCommon.topFilters.searchAccounts.placeholder"
    }), /*#__PURE__*/_jsx(LazyLoadScrollContainer, Object.assign({
      data: playlistAssignmentsPortals,
      loadNextPage: () => setPage(page + 1),
      loading: playlistAssignmentsPortalsLoading,
      page: page,
      render: render,
      state: query,
      total: total || 0
    }, props))]
  });
};
export const PlaylistAssignmentsSearch = _ref3 => {
  let {
      playlistId,
      portalId: propPortalId,
      renderAssignments,
      renderPortals
    } = _ref3,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  const {
    playlistAssignmentsPortals,
    total
  } = usePlaylistAssignmentsPortals({
    playlistId
  });
  const {
    selectedPortalId: contextPortalId
  } = useContext(PlaylistAssignmentsSearchContext);
  const uniquePortalId = total === 1 && playlistAssignmentsPortals && playlistAssignmentsPortals.length ? playlistAssignmentsPortals[0].portal.id : undefined;

  /** we extract selected portal ID from either the context, component props or if there is only one portal for this playlist
   * (doesn't show list of portals if there is only one)*/
  const selectedPortalId = contextPortalId || propPortalId || uniquePortalId;
  return selectedPortalId ? /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalSearch, Object.assign({
    playlistId: playlistId,
    portalId: selectedPortalId,
    render: renderAssignments
  }, props)) : /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsSearch, Object.assign({
    playlistId: playlistId,
    render: renderPortals
  }, props));
};
export default PlaylistAssignmentsSearch;